// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__g5T+N","hero_image":"style_hero_image__nvjxq","image_wrapper":"style_image_wrapper__kNNnr","hero_img":"style_hero_img__TV39W"};